<template>
    <sections>
        <section-contact
            heading="Contact"
            content="<p>We're here to help. Reach out to us today.</p>"
        ></section-contact>
    </sections>
</template>

<script setup>
const $config = useRuntimeConfig();
useSeo().buildHead({
    title: 'Contact | ' + $config.public.siteName,
    description: "We're here to help. Reach out to us today.",
    index: true,
});
</script>
